// @flow

import { has } from 'lodash-es'

export const getWebFallback = state =>
  has(state, 'init.default_uk_logo') ? state.init.default_uk_logo : ''

export const getMobileFallback = state =>
  has(state, 'init.default_mobile_logo') ? state.init.default_mobile_logo : ''
